var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaChambreDesUrgences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.855 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 787",
    d: "M68.262 36.848a3.592 3.592 0 0 0-3.592 3.6v1.2H29.583L7.19 26.89a3.6 3.6 0 0 0-7.186.383v31.135a3.593 3.593 0 0 0 7.185 0v-1.2h57.48v1.2a3.593 3.593 0 0 0 7.185 0v-17.96a3.592 3.592 0 0 0-3.592-3.6ZM4.795 58.408a1.2 1.2 0 0 1-2.395 0V27.273a1.2 1.2 0 1 1 2.395 0Zm2.395-3.593V29.776l21.375 14.072a1.2 1.2 0 0 0 .659.192H64.67v10.775Zm62.27 3.593a1.2 1.2 0 0 1-2.395 0v-17.96a1.2 1.2 0 1 1 2.395 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 788",
    d: "M9.585 22.483a4.79 4.79 0 1 0 4.79-4.79 4.79 4.79 0 0 0-4.79 4.79Zm4.79-2.395a2.395 2.395 0 1 1-2.395 2.395 2.395 2.395 0 0 1 2.395-2.395Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 789",
    d: "M19.704 27.788a3.593 3.593 0 0 0 1.138 4.886l9.726 6.371a1.2 1.2 0 0 0 .659.2h28.741a3.593 3.593 0 1 0 0-7.185H33.331c-3.528-2.041-3.175-1.953-5.784-3.592l-2.862-1.805a3.485 3.485 0 0 0-2.742-.431 3.593 3.593 0 0 0-2.239 1.556Zm2.024 1.269a1.305 1.305 0 0 1 .778-.551 1.2 1.2 0 0 1 .9.132l8.933 5.628a1.2 1.2 0 0 0 .647.192h26.982a1.2 1.2 0 0 1 1.2 1.2 1.257 1.257 0 0 1-1.2 1.2h-28.4l-9.436-6.191a1.2 1.2 0 0 1-.407-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 792",
    d: "M20.606 10.678h9.95a1.405 1.405 0 0 0 1.222-.746l2.729-4.875 4.662 13.71a1.438 1.438 0 0 0 1.251 1.005h.085a1.415 1.415 0 0 0 1.265-.838l4.421-9.414 3 6.413a1.415 1.415 0 0 0 1.265.838h14.216a1.527 1.527 0 0 0 0-3.047H51.339l-3.881-8.3a1.38 1.38 0 0 0-2.53 0l-4.264 9.016-4.507-13.42A1.443 1.443 0 0 0 34.963.01a1.394 1.394 0 0 0-1.421.746l-3.8 6.87h-9.14a1.527 1.527 0 0 0 0 3.047Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaChambreDesUrgences);
export default __webpack_public_path__ + "static/media/la-chambre-des-urgences.a90153f0c949ad3df69d6dbffc6bf021.svg";
export { ForwardRef as ReactComponent };